import { LANG } from '@bm-js/atlascloud-shared'
import { createContext } from 'react'
import { _objectKeys } from '@naturalcycles/js-lib/types'
import { TRANSLATIONS_SE } from '../cnst/translations/sv.cnst'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { TRANSLATIONS_EN } from '../cnst/translations/en.cnst'
import { _stringEnumValues } from '@naturalcycles/js-lib'

export const langLabels: Record<LANG, string> = {
  [LANG.EN_US]: 'English',
  [LANG.SV_SE]: 'Svenska',
}

export const ALL_TRANSLATIONS: Record<LANG, Translations> = {
  [LANG.EN_US]: TRANSLATIONS_EN,
  [LANG.SV_SE]: TRANSLATIONS_SE,
}

export function getLangFromLs(): LANG | null {
  const lsLang = localStorage.getItem(LANG_LS_KEY) as LANG
  return lsLang && _stringEnumValues(LANG).includes(lsLang as LANG)
    ? lsLang
    : null
}

export const LANG_LS_KEY = 'atlascloud-user-lang'

export type Translations = Record<TrKey, string>

interface LangState {
  currentLang: LANG
  changeLang: (lang: LANG) => void
  availableLangs: LANG[]
  translations: Translations
}

export const LangContext = createContext<LangState>({
  currentLang: LANG.SV_SE,
  changeLang: () => {},
  availableLangs: _objectKeys(ALL_TRANSLATIONS),
  translations: ALL_TRANSLATIONS[LANG.SV_SE],
})
